import React, { useState, useEffect } from 'react';
import './index.css';
import TopSearches from './topSearches';
import RightDrawer from './rightDrawer';
import SearchFields from './searchFields';
import SearchResults from './../result/index';
import { message } from "antd";
import * as com from "../../../../Common.js";

const SearchBox = (paramsFromRightDrawer) => {
    const [showResults, setShowResults] = useState(false);
    const [loading, setLoading] = useState(false);
    const [searchParams, setSearchParams] = useState(null);
    const [customerid, setCustomerid] = useState(null);
    const [historyParams, setHistoryParams] = useState(null);
    const [search, setSearch] = useState(false);

    const formatSearchParams = (searchParams) => {
        // console.log("searchParams", searchParams);
    
        const params = {
          // 固定标志位
          Rate_CRAAdjustment: false,
          Rate_LMIBAdjustment: false,
          Rate_LMITAdjustment: false,
          Rate_MMCTAdjustment: false,
          appraisalWaiver: false,
          borrowerPaidCompensationAmount: 0,
          currentJobInMonths: 24,
          familyRelatedOrSmallBusiness: false,
          getFiles: true,
          giftFundUsed: false,
          numberOfOwnedProperties: 1,
          pmi: 0.51,
          point: [{lender: "default", percent: 1, fixed: 500}],
          rsuAsIncome: -1,
          unit: 1,
          visaType: "H_1B",

          // loan 相关参数
          purpose: searchParams.purpose,
          loanTerm: searchParams.loanTerm,
          loanTypes: searchParams.loanTypes,
          propertyValue: Number(searchParams.propertyValue || 0),
          downPayment: Number(searchParams.downPayment || 0),
          loanAmount: Number(searchParams.loanAmount || 0),
          LTV: Number(searchParams.LTV || 0),
          CLTV: Number(searchParams.CLTV || 0),
          HCLTV: Number(searchParams.HCLTV || 0),
          secondaryLoanAmount: Number(searchParams.secondaryLoanAmount || 0),

          // property 相关参数
          occupancy: searchParams.occupancy,
          property: searchParams.property,
          state: searchParams.state,
          county: searchParams.county,
          isRural: searchParams.isRural || false,
          isMixedUseProperty: searchParams.isMixedUse || false,

          // borrower 相关参数
          FICO: Number(searchParams.FICO || 0),
          monthlyIncome: Number(searchParams.monthlyIncome || 0),
          monthlyDebt: Number(searchParams.monthlyDebt || 0),
          dti: Number(searchParams.dti || 0),
          citizenship: searchParams.citizenship || "US_CITIZENS",
          firstTimeHomeBuyer: searchParams.firsttimehomebuyer || false,
          selfEmployed: searchParams.selfemployed || false,

          // product 相关参数
          searchBy: searchParams.searchBy || "price",
          targetPrice: searchParams.searchBy === "rate" ? 100 : Number(searchParams.targetPrice || 7),
          targetRate: searchParams.searchBy === "rate" ? Number(searchParams.targetRate || 0) : Number(searchParams.targetPrice || 1),
          targetPriceType: searchParams.targetPriceType || [""],
          lockDay: Number(searchParams.lockDay || 30),
          compensationType: searchParams.compensationType || "",
          compensationPercent: Number(searchParams.compensationPercentage || 0),
          estimatedClosingFee: Number(searchParams.estimatedClosingCosts || 0),
          ausTypes: searchParams.ausTypes || [],
          buyDown: searchParams.buydown || "",
          isImpound: searchParams.isImpound || false,
          escrowWaiver: !searchParams.isImpound,
          isInterestOnly: searchParams.isInterestOnly || false,
          isWaiveLenderFee: searchParams.isWaiveLenderFee || false,
        };
    
        return params;
      };

    const handleCheckRates = (body) => {
        // console.log('handleCheckRates---', body)   
        setSearch(false);
        setTimeout(() => {
            setLoading(true);
            // 添加时间戳确保每次调用都有变化
            setSearchParams({...body, _timestamp: Date.now()});
            setCustomerid(localStorage.getItem("customerid"));
            setShowResults(true);
            // setSearch(true);
        }, 0);
    };

    const handleApplyParams = (params) => {
        // console.log('apply params from top search', params)
        // setHistoryParams(params);
        handleCheckRates((formatSearchParams({...params, downPayment: params.propertyValue - params.loanAmount})));
    }

    const handleRefineSearch = (params) => {
        // console.log('refine search', params)
        setHistoryParams({...params, from: "result"});
    }

    const handleBackToResult = () => {
        setShowResults(true);
        setSearch(false);
    }

    useEffect(() => {
        // console.log('apply params from right drawer', paramsFromRightDrawer, paramsFromRightDrawer.params.purpose)
        if(paramsFromRightDrawer.params.purpose) {
            setShowResults(false);
            // setHistoryParams(paramsFromRightDrawer.params.parameters);
            handleCheckRates((formatSearchParams({...paramsFromRightDrawer.params.parameters, downPayment: paramsFromRightDrawer.params.parameters.propertyValue - paramsFromRightDrawer.params.parameters.loanAmount})));
        }
    },[paramsFromRightDrawer])

    const showTopSearches = sessionStorage.getItem("showTopSearches") !== "false";

    return <div className='search-box'>
        {!showResults && showTopSearches && <TopSearches onApplyParams={handleApplyParams} />}
        {!showResults && <SearchFields onCheckRates={handleCheckRates} historyParams={historyParams} onBackToResult={handleBackToResult}/>}
        {searchParams && <SearchResults 
            style={{display: showResults ? "block" : "none"}}
            searchParams={searchParams} 
            customerid={customerid}
            loading={loading}
            setLoading={setLoading}
            search={search}
            setChangeShowResults={() => setShowResults(false)}
            onRefineSearch={handleRefineSearch}
        />}
    </div>;
};

export default SearchBox;